import axios from "axios"

export const useConfigApi = () => {
    const baseURL = process.env.REACT_APP_BASE_URL;

    const api = axios.create({
        headers: {
            Accept: "application/json",
        }
    });


    return { api, baseURL };
};